import React from 'react'
import {Link} from "react-router-dom";


import mainbanner from "../images/BANNER Main.jpg";
import labtest from "../images/BANNER new.jpg"



function Slider() {
  return (
    <div>

<div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <Link to="/find-doctor">
      <div className='borderradius'>
      <img src={mainbanner} className="d-block w-100" alt="elitemedical care"/>
      </div>
      </Link>
    </div>
    <div className="carousel-item"> 
    <div className='borderradius'>
      <img src={labtest} className="d-block w-100" alt="Elite Medical Care"/>    
      </div>
    </div>
  

  
    
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider